module.exports = __webpack_public_path__ + "img/twwky2.38854ab8.jpg";